import React from 'react'
// libs
import { Field } from 'redux-form'
// hooks
import { useShowModal } from 'hooks'
// themes
import { get } from 'lodash/fp'
// views
import { Panel } from './views'
// constants
import { Modals } from 'constants/index'
import { WrappedFieldProps } from 'redux-form/lib/Field'

interface Props {
  name: string
  children: (value: any) => React.ReactNode
  decorated?: boolean
}

const Component: React.FC<Props & WrappedFieldProps> = ({ children, input, ...rest }) => {
  const { showModal: showSetColorModal } = useShowModal({ modalType: Modals.SET_COLOR_MODAL })

  const handleFormSubmit = (data: any) => {
    const hex = get('color.hex', data)

    input.onChange(hex)
  }

  const handleOnClick = () => showSetColorModal({ onSubmit: handleFormSubmit })

  return (
    <Panel color={input.value} onClick={handleOnClick} {...rest}>
      {children(input.value)}
    </Panel>
  )
}

const ReduxColorPanel: React.FC<Props> = (props) => <Field {...props} component={Component} />

export default ReduxColorPanel
